const Success = () => {
  return (
    <div>
      <h1>Payment Successful </h1>

      <p>Your order has been confirmed.</p>

      <button onClick={() => (window.location.href = "/")}>
        Go Home
      </button>
    </div>
  );
};

export default Success;